var map = {
	"./all_screen.png": 84187,
	"./btnborder_y.png": 93937,
	"./dy_icon_01.png": 14508,
	"./dy_icon_02.png": 81543,
	"./dy_icon_03.png": 5758,
	"./dy_icon_04.png": 50321,
	"./dy_img.png": 90686,
	"./gd_icon.png": 56652,
	"./hunan_map.png": 28960,
	"./hunan_map.webp": 20141,
	"./number_card_bg.png": 50577,
	"./rank_b.png": 89138,
	"./rank_y.png": 54241,
	"./ring_color_01.png": 69699,
	"./ring_color_02.png": 91368,
	"./ring_color_03.png": 39761,
	"./screen_bg.png": 18909,
	"./screen_bg.webp": 15598,
	"./time_icon.png": 54598,
	"./tooltip_bg.png": 34270,
	"./zd_icon1.png": 17472,
	"./zd_icon2.png": 98683,
	"./zd_icon3.png": 93490,
	"./zd_icon4.png": 23469,
	"./zd_img.png": 41789,
	"./娄底市_431300.png": 17976,
	"./娄底市_431300.webp": 62181,
	"./岳阳市_430600.png": 14297,
	"./岳阳市_430600.webp": 28850,
	"./常德市_430700.png": 45489,
	"./常德市_430700.webp": 98218,
	"./张家界市_430800.png": 41675,
	"./张家界市_430800.webp": 90640,
	"./怀化市_431200.png": 76650,
	"./怀化市_431200.webp": 79835,
	"./株洲市_430200.png": 88691,
	"./株洲市_430200.webp": 22552,
	"./永州市_431100.png": 78041,
	"./永州市_431100.webp": 72018,
	"./湘潭市_430300.png": 90295,
	"./湘潭市_430300.webp": 35924,
	"./湘西州_433100.png": 75522,
	"./湘西州_433100.webp": 76403,
	"./益阳市_430900.png": 54973,
	"./益阳市_430900.webp": 32334,
	"./衡阳市_430400.png": 54169,
	"./衡阳市_430400.webp": 70898,
	"./邵阳市_430500.png": 41036,
	"./邵阳市_430500.webp": 40897,
	"./郴州市_431000.png": 27892,
	"./郴州市_431000.webp": 15241,
	"./长沙市_430100.png": 16224,
	"./长沙市_430100.webp": 83341
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;